import { storage } from '@uhg-abyss/web/tools/storage';

const CACHE_KEY = '@uhc/usercache';

const createToken = (params) => {
  try {
    return btoa(JSON.stringify(params));
  } catch (e) {
    return null;
  }
};

const parseToken = (token) => {
  try {
    return JSON.parse(atob(token));
  } catch (e) {
    return null;
  }
};

export const usercache = {
  set: (key, data) => {
    const cacheToken = storage.local.get(CACHE_KEY);
    let cacheData = parseToken(cacheToken) || {};

    if (key === 'uuid' && cacheData.uuid !== data) {
      cacheData = {};
    }

    const newToken = createToken({ ...cacheData, [key]: data });
    storage.local.set(CACHE_KEY, newToken);
  },
  get: (key) => {
    const cacheToken = storage.local.get(CACHE_KEY);
    const cacheData = parseToken(cacheToken) || {};
    return cacheData[key];
  },
  remove: (key) => {
    const cacheToken = storage.local.get(CACHE_KEY);
    const cacheData = parseToken(cacheToken) || {};
    delete cacheData[key];
    const newToken = createToken(cacheData);
    storage.local.set(CACHE_KEY, newToken);
  },
};
